import React from 'react';
import CKEditor from "react-ckeditor-component";
import {isEqual} from 'lodash';
import { change } from 'redux-form';
import Loading from '../Loading';

class FieldCkEditor extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            content : this.props.input.value,
        };

        this.onChange = this.onChange.bind(this);
        this.shouldComponentUpdate = this.shouldComponentUpdate.bind(this);

    }


    shouldComponentUpdate(nextProps, nextState, nextContext) {

        if (!isEqual(this.props.input, nextProps.input))
        {
            return true
        }
        return false
    }

    onChange(evt){
        let newContent = evt.editor.getData();
        this.setState({
            content: newContent
        });

        this.props.meta.dispatch(change(this.props.meta.form, this.props.input.name, newContent));
    }

    onBlur(evt){
    }

    afterPaste(evt){
    }

    render() {

        const { name, input, label, type, help, bsSize, placeholder, meta: { touched, error } } = this.props;
        const config = {
            toolbar : [[ 'Bold', 'Italic', 'Underline', '-', 'JustifyLeft','JustifyCenter','JustifyRight', '-', 'BulletedList', 'NumberedList','-', 'Styles', 'Format', 'Unlink', 'Link' ]],
        };

        return (

            <div className="animated fadeIn">

                <CKEditor
                    config={config}
                    content={input.value}
                    name={name}
                    events={{
                        "blur": this.onBlur,
                        "afterPaste": this.afterPaste,
                        "change": this.onChange,
                    }}
                />

            </div>

        )
    }
};

export default FieldCkEditor;


// WEBPACK FOOTER //
// ./src/components/Form/wh-ckeditor.js